/// <reference path="../../Common/Helpers/GridEditorBase.ts" />


namespace RioERP.Carts {
    
    @Serenity.Decorators.registerEditor()
    export class CartProductsEditor extends Common.GridEditorBase<CartProductsRow> {
        protected getColumnsKey() { return 'Carts.CartProducts'; }
        protected getDialogType() { return CartProductsEditDialog; }
     
        protected getLocalTextPrefix() { return CartProductsRow.localTextPrefix; }
        public stateid: number;
        public FranchiseeId: number;
        constructor(container: JQuery) {
            super(container);
        }

        protected getAddButtonCaption() {
            return "Add";   
        }

        protected initEntityDialog(itemType: string, dialog: Serenity.Widget<any>) {
            super.initEntityDialog(itemType, dialog);
            //debugger;
            // passing discount from grid editor to detail dialog
            //(dialog as OrderProductsEditDialog).stateIds = this.stateid;
            if (this.FranchiseeId == null) {
                //Q.alert("Please select Franchisee First");
                return;
            }
            else {
                (dialog as CartProductsEditDialog).FranchiseeId = this.FranchiseeId;                
            }
            
        }
         protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);
           

            return buttons;
        }

        //validateEntity(row, id) {
        //    row.ProductId = Q.toId(row.ProductId);

        //    var sameProduct = Q.tryFirst(this.view.getItems(), x => x.ProductId === row.ProductId);
        //    if (sameProduct && this.id(sameProduct) !== id) {
        //        Q.alert('This Product is already added!');
        //        return false;
        //    }           
        //    return true;
        //}
    }
}